import React, { FunctionComponent } from "react";
import { base64url } from "rfc4648";
import Highlight, {
  defaultProps,
  Language as PrismLanguage,
  Prism,
} from "prism-react-renderer";
import theme from "prism-react-renderer/themes/dracula";
import { Grid, Segment } from "semantic-ui-react";
import "./style.scss";

//@ts-ignore
(typeof global !== "undefined" ? global : window).Prism = Prism;

require("prismjs/components/prism-http");
require("prismjs/components/prism-objectivec");
require("prismjs/components/prism-swift");

const LineNo = ({ children }) => (
  <span
    style={{
      display: "inline-block",
      width: "2em",
      userSelect: "none",
      opacity: 0.3,
    }}
  >
    {children}
  </span>
);

export const JWT = ({ children }) => {
  const parts = children.split(".");

  return (
    <Grid columns={2} stackable>
      <Grid.Column>
        <Segment>
          <pre
            style={{
              wordWrap: "break-word",
              whiteSpace: "break-spaces",
            }}
          >
            <span style={{ color: "#fb015b" }}>{parts[0]}</span>.
            <span style={{ color: "#d63aff" }}>{parts[1]}</span>.
            <span style={{ color: "#00b9f1" }}>{parts[2]}</span>
          </pre>
        </Segment>
      </Grid.Column>
      <Grid.Column verticalAlign="middle">
        <JWT.Part children={parts[0]} title="Header" />
        <JWT.Part children={parts[1]} title="Payload" />
      </Grid.Column>
    </Grid>
  );
};

JWT.Part = ({ children, title }) => {
  if (!children) return <></>;
  const decoded = JSON.stringify(
    JSON.parse(
      new TextDecoder().decode(base64url.parse(children, { loose: true }))
    ),
    null,
    2
  );
  return (
    <CodeBlock code={decoded} language="json" scroll={true} title={title} />
  );
};

export type Language = PrismLanguage | "http" | "text";

export type Props = {
  code: string;
  className?: string;
  lineNumbers?: boolean;
  title?: string;
  scroll?: boolean | string;
  language: Language;
  actionBar?: JSX.Element;
};

const CodeBlock: FunctionComponent<Props> = ({
  code,
  // className,
  lineNumbers,
  title,
  scroll = true,
  language,
  actionBar,
}) => {
  let custom_styles = {};
  if (scroll === "false") scroll = false;
  if (!scroll)
    custom_styles = { overflowWrap: "break-word", whiteSpace: "break-spaces" };
  return (
    <Highlight
      {...defaultProps}
      code={code}
      //@ts-ignore
      language={language}
      theme={theme}
      Prism={Prism}
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <div>
          {title ? (
            <Segment
              basic
              clearing
              style={{
                backgroundColor: "rgb(29, 31, 39)",
                color: "rgba(248, 248, 242, 0.75)",
                fontSize: "12px",
                lineHeight: "18px",
                margin: 0,
                padding: 0,
              }}
            >
              <span
                style={{
                  padding: "10px 0 10px 10px",
                  display: "inline-block",
                }}
              >
                {title}
              </span>
              {actionBar ? (
                <div style={{ float: "right" }}>{actionBar}</div>
              ) : (
                ""
              )}
            </Segment>
          ) : (
            ""
          )}
          <pre
            className={className}
            style={{
              ...style,
              padding: "8px",
              overflow: "auto",
              marginTop: 0,
              marginBottom: 0,
              ...custom_styles,
            }}
          >
            {tokens.map((line, i) => (
              <div key={i} {...getLineProps({ line, key: i })}>
                {lineNumbers ? <LineNo>{i + 1}</LineNo> : ""}
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </div>
            ))}
          </pre>
        </div>
      )}
    </Highlight>
  );
};
export default CodeBlock;
